module.exports = __webpack_public_path__ + "static/media/s2.3b2c023a.png";